export class PostGetPatientRegistryAffiliationRequest {
    patientId: string = "";
}